import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Box, Card, Chip, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { usePackagesInSameLicenseFile } from '../../hooks/usePackagesInSameLicenseFile';
import { useIsPixotopeUser } from '../../hooks/useIsAdmin';

const StyledTable = styled(Table)({
  '& tbody tr:last-of-type td': {
    borderBottomColor: 'transparent',
  },
});

export const LicensesIncludedInOffline: FC = () => {
  const { t } = useTranslation();

  const licenses = usePackagesInSameLicenseFile();

  const isPixotopeUser = useIsPixotopeUser();

  return (
    <Box mb={2}>
      <Card>
        <Box p={1}>
          {t('licenses.includedInFile')}
          <StyledTable>
            {isPixotopeUser ? (
              <TableHead>
                <TableRow>
                  <TableCell>{t('common.tableHeader.id')}</TableCell>
                  <TableCell>{t('common.tableHeader.license')}</TableCell>
                </TableRow>
              </TableHead>
            ) : null}
            <TableBody>
              {licenses.all.map((license) => (
                <TableRow key={license.id}>
                  {isPixotopeUser ? <TableCell width={70}>{license.id}</TableCell> : null}
                  <TableCell>
                    {license.isAddon ? (
                      <>
                        <Chip color="info" label={t('assignLicenses.addonChip')} />{' '}
                      </>
                    ) : null}
                    {license.name}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </StyledTable>
        </Box>
      </Card>
    </Box>
  );
};
